import React from 'react';

const Portfolio = () => {
	return (
		<div className='container'>
			<h1 className='animate__animated animate__fadeInUp'>Portfolio</h1>
		</div>
	);
};

export default Portfolio;
